// ConfettiCustom - Renderer System
import { ConfettiPiece, RendererConfig } from './types';

export class ConfettiRenderer {
  private canvas: HTMLCanvasElement;
  private ctx: CanvasRenderingContext2D;
  private config: RendererConfig;

  constructor(canvas: HTMLCanvasElement, config: RendererConfig) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d')!;
    this.config = config;
    
    this.setupCanvas();
  }

  private setupCanvas(): void {
    this.canvas.width = this.config.width;
    this.canvas.height = this.config.height;
    this.ctx.imageSmoothingEnabled = true;
  }

  /**
   * Limpa o canvas
   */
  clear(): void {
    this.ctx.clearRect(0, 0, this.config.width, this.config.height);
  }

  /**
   * Renderiza uma partícula de confete
   */
  renderPiece(piece: ConfettiPiece): void {
    this.ctx.save();
    
    // Aplicar transparência baseada na vida da partícula
    this.ctx.globalAlpha = piece.life;
    
    // Mover para a posição da partícula
    this.ctx.translate(piece.x, piece.y);
    
    // Aplicar rotação
    this.ctx.rotate((piece.rotation * Math.PI) / 180);
    
    // Definir cor
    this.ctx.fillStyle = piece.color;
    
    // Desenhar forma baseada no tipo
    this.drawShape(piece);
    
    this.ctx.restore();
  }

  /**
   * Desenha a forma específica da partícula
   */
  private drawShape(piece: ConfettiPiece): void {
    const halfSize = piece.size / 2;
    
    switch (piece.shape) {
      case 'square':
        this.ctx.fillRect(-halfSize, -halfSize, piece.size, piece.size);
        break;
        
      case 'circle':
        this.ctx.beginPath();
        this.ctx.arc(0, 0, halfSize, 0, 2 * Math.PI);
        this.ctx.fill();
        break;
        
      case 'rectangle':
        this.ctx.fillRect(-halfSize, -halfSize * 0.6, piece.size, piece.size * 0.6);
        break;
        
      case 'triangle':
        this.ctx.beginPath();
        this.ctx.moveTo(0, -halfSize);
        this.ctx.lineTo(-halfSize, halfSize);
        this.ctx.lineTo(halfSize, halfSize);
        this.ctx.closePath();
        this.ctx.fill();
        break;
    }
  }

  /**
   * Atualiza as dimensões do canvas
   */
  updateDimensions(width: number, height: number): void {
    this.config.width = width;
    this.config.height = height;
    this.setupCanvas();
  }
}
